import { forwardRef } from "react";
import { ListItem as MuiListItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { mergeWith } from "lodash";

import { colors } from "theme";

const useStyles = makeStyles(() => ({
  root: {
    padding: "9px 16px !important",
    "&:hover": {
      backgroundColor: colors.catSkill,
    },
  },
}));

const ListItem = forwardRef(
  ({ classes = {}, ...otherProps }: any, ref: any) => {
    const baseClasses = useStyles();
    const menuItemClasses = mergeWith(
      baseClasses,
      classes,
      (class1: string, class2: string) => `${class1} ${class2}`
    );

    return <MuiListItem ref={ref} {...otherProps} classes={menuItemClasses} />;
  }
);

export default ListItem;
